import { CheckIcon, XIcon } from 'lucide-react'

import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

type IsSuggestionAcceptedBadgeProps = {
  isSuggestionAccepted: boolean
}

export const IsSuggestionAcceptedBadge = ({
  isSuggestionAccepted,
}: IsSuggestionAcceptedBadgeProps) => {
  return (
    <TextWithIcon
      className='text-main-foreground-primary text-label-default'
      text={isSuggestionAccepted ? 'Accepted' : 'Rejected'}
      icon={
        isSuggestionAccepted ? (
          <CheckIcon className='text-main-foreground-success' size={14} />
        ) : (
          <XIcon className='text-main-foreground-danger' size={14} />
        )
      }
    />
  )
}
